<template>
    <div class="modal" tabindex="-1" id="display-lesson-modal">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header bg-custom">
                    <div class="row text-center ">
                        <!-- <span><strong>Lesson:</strong></span><h3 v-html="lessondata.name"></h3> -->
                        <span class="text-center" v-html="getLessonHeading(lessondata.name)"></span>
                    </div> <div class="row">
                    <button type="button" @click="cancel" class="close" title="Close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true"><i class="fa fa-window-close" ></i></span>
                    </button>
                    </div>
                </div>
                <div class="modal-body">
                    <div class="row" >
                        <div class="col">
                            <div v-if="lessondata" style="visibility:block;">
                                <div class="c-item bg-secondary"><em><small v-html="lessondata.intro_text"></small></em></div>
                                <!-- <div  v-if="lessondata.videourl && lessondata.videourl!=''" class="video-container fitVids-wrapper" style="position:relative;padding-bottom:56.25%;padding-top:30px;height:0;overflow:hidden;">
                                <iframe width="560px" height="315px" :src="lessondata.videourl" frameborder="0" allowfullscreen></iframe>
                                    <object style="position:absolute;top:0;left:0;width:100%"></object>
                                    <embed style="position:absolute;top:0;left:0;width:100%"/>
                                </div> -->

                        <div v-if="lessondata.videourl && lessondata.videourl!=''" class="embed-responsive embed-responsive-16by9 mb-8">
                                <iframe id='video4' :src="lessondata.videourl"
                                    frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                        </div>

                                <div class="card border-dark p-4 mt-4" v-if="lessondata.image_uri && lessondata.image_uri!=''" ><img  class="mx-auto img-thumbnail my-2 d-block" :src="'/storage/' + lessondata.image_uri" width='80%' /></div>
                                <!-- <div  v-if="lessondata.download_id!=''" v-html="lessondata.download_id"></div> TODO IMPLEMENT DOWNLOAD -->
                                <div v-html="lessondata.main_text"></div>
                                <button class="btn btn-sm btn-warning float-right mx-2 my-2" @click="cancel">Close</button>
                                <button class="btn btn-sm btn-primary float-right  mx-2 my-2" @click="saveLessonDone(lessondata.id)">Done</button>
                                <!-- <button class="btn btn-sm btn-primary float-right  mx-2 my-2" @click="saveLessonIncomplete(lessondata.id)">Incomplete</button> -->
                            </div>
                        </div>
                    </div>
                    <!-- Last updated: {{lessondata.updated_at}} -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import EventBus from '../../../event-bus';
import Editor from '@tinymce/tinymce-vue';
import '../../../video.js';

import { v4 as uuidv4 } from 'uuid';

export default {
    components: {
        lessonIntro: Editor,
        lessonOther: Editor,
        lessonMain: Editor,
     },
    name: "DisplayLesson",
    data() {
        return {
            csrf_token: document.head.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            userinfo:'',
            lessondata:{},
            trakdata:[],
            course_id: '',
        }
    },

    props: {
        user:'',
        apikey:'',
    },
    mounted() {
            this.userinfo = JSON.parse(this.user);

            EventBus.$on('displayLesson', (data) => {
                console.error(data.lessonid);
                this.retrieveLesson(data.lessonid);
                this.course_id = data.course_id;
                this.$forceUpdate();
                $('div#display-lesson-modal').modal('show');
            });
    },
    methods: {
        getLessonHeading(name){
            return 'Lesson: <h3>'+name + '</h3>';
        },
                setupImage(imageID) {
            //reset image to nothing first
            this.dropImage('imageDisplay1');
            if(this.sel_image_id != '') this.displayImage(imageID);
        },
        getLesson(lessonid) {
            var theLesson = '';
            [...this.allLessonsData].forEach(aLesson=>{
                if(aLesson.id == lessonid) theLesson = aLesson;
            });
            return theLesson;
        },
        setupDownload() {
            this.sel_download = this.getItemByID('pdf', this.sel_download_id);
        },

        retrieveLesson(lessonid) {
            axios.get('/edu/lesson/' + lessonid)
            .then(res => {
                this.loading = false;
                this.success = true;
                this.lessondata = JSON.parse(res.data.lesson);
            })
            .catch(err => {
                console.error(err);
                this.updateToast(err.message, 4000, 'error');
            })
            .finally(()=> {
                // location.reload();
            });
        },


        displayImage(id, uri) {
            var tagid = 'imageDisplay1';
            this.dropImage(tagid);
            console.log('displayImage For tag: ' + tagid + ", id: " + id);
            var image = this.getItemByID('image', id);
            var uripath = !uri? image.file_path: uri;
            this.lessondata.image_uri = uripath;
            const html = `<img src='/storage/` + uripath + `' width='100%' >`;
            document.getElementById(tagid).innerHTML = html;
            return image;
        },
        dropImage(tagid) {
            this.lessondata.imag_uri = '';
            document.getElementById(tagid).innerHTML = '';
        },

        trackLessonProgress() {
            axios.post('/edu/lesson/trak', {
                user_id: this.userinfo.id,
                lesson_id: this.lesson_id,
                course_id: this.course_id,
                lessoncat_id: this.lessoncat_id,
                perc_done: this.perc_done,
                status: this.perc_done==100? 'completed':'in_progress',

            })
            .then(res => {
                this.loading = false;
                this.success = true;
                this.message = res.data.message;
                this.updateToast(this.message, 4000);
                console.error(res.data.message);
                this.lessondata = JSON.parse(res.data.lesson);
                EventBus.$emit('refreshLessonParent');

            })
            .catch(err => {
                // this.loading = false;
                // this.failure = true;
                // this.success = false;
                console.error(err);
                this.updateToast(err.message, 4000, 'error');
            })
            .finally(()=> {
                // location.reload();
            });

        },


        modalReset() {
            //set all fields to blank
            this.lessondata.id = '';
            this.lessondata.name = '';
            this.lessondata.byline = '';
            this.lessondata.owner_id = '';
            this.lessondata.description = '';
            this.lessondata.blurb_heading = '';
            this.lessondata.image_id = '';
            this.lessondata.image_uri = '';
            this.lessondata.download_id = '';
            this.lessondata.main_text = '';
            this.lessondata.intro_text = '';
            this.lessondata.order_num = '';
            this.lessondata.videourl = '';

        },
        cancelLessonCat() {
            console.log("Cancel close FSLifeArea");
            $('div#display-lesson-modal').modal('hide');
            EventBus.$emit('refreshParentPage');
            // location.reload();
        },
        getTemplate(life_area) {
             console.log("Looking for template with id " + life_area);
            return this.templates.find((template) =>{
                    // console.log(life_area + ' : '+ template.life_area);
                if(template.life_area == life_area) {
                    // console.log("Found template...");
                    return template;
                }
            });
        },
        getInitMenuPlugins() {
            return {
                height: 200,
                // theme: 'advanced',
                menubar: false,
                // plugins: [
                //     'code table lists'
                // ],
                readonly: 1,
                // toolbar:
                //     'undo redo | formatselect | bold italic backcolor | \
                //     alignleft aligncenter alignright alignjustify | \
                //     bullist numlist outdent indent | removeformat | help'
            }
        },
        saveLessonStatus(lesson_id, status) {
             console.log('Tracking for ' +  lesson_id);
            if(this.lessondata.id != '') {
                axios.post('/learning/track/'+ lesson_id, {
                    user_id:this.userinfo.id,
                    lessoncat_id:this.lessondata.lesson_category_id,
                    course_id:this.course_id,
                    status:status,
                    perc_done:status=='done'?100:0,
                })
                .then(res => {
                    this.loading = false;
                    this.success = true;
                    this.message = res.data.message;
                    this.updateToast(this.message, 4000);
                    console.error(res.data.message);
                })
                .catch(err => {
                    // this.loading = false;
                    // this.failure = true;
                    // this.success = false;
                })
                .finally(()=> {
                    location.reload();
                });
            }
        },

  saveLessonDone(lesson_id) {
    this.saveLessonStatus(lesson_id, 'done');
  },
  saveLessonIncomplete(lesson_id) {
        this.saveLessonStatus(lesson_id, 'inprogress');
  },


        updateToast(message, timer = 2000, icon='success') {
            const Toast = Swal.mixin({
                position: 'center',
                width: 500,
                showConfirmButton: true,
            });
            Toast.fire({
                icon: icon,
                title: message
            });
        },
        cancel() {
            $('div#display-lesson-modal').modal('hide');
        }

    },
    computed: {
    },
}
</script>
<style>
.bg-custom{
    background: #449acb;
color: #fff;
}
.fitVids-wrapper {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
}
.fitVids-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
